import { render } from "./PersonPage.vue?vue&type=template&id=b416e590&scoped=true"
import script from "./PersonPage.vue?vue&type=script&lang=js"
export * from "./PersonPage.vue?vue&type=script&lang=js"

import "./PersonPage.vue?vue&type=style&index=0&id=b416e590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b416e590"]])

export default __exports__